import { useQuery } from 'react-query';
import Button from '../ui/Button';
import './UserDetails.scss';
import Loader from '../ui/Loader';
import { getSpecificUser } from '../../api/hospitalsAPI';

const UserDetails = ({
    userId, 
    onDecline,
}) => {
    const userQuery = useQuery(['user-info', userId], () => getSpecificUser(userId), {
        staleTime: 3000000, 
        enabled: !!userId 
    });

    if (userQuery.isLoading) return <Loader />;
    if (userQuery.isError) return <p>Error loading user data</p>;
    
    const user = userQuery.data.data.data.user;
    return (
        <div className='user-details-container'>
            <div className='general-container'>
                <div className='title'>
                    <h2>User Details</h2>
                </div>
                <div className='info-container'>
                    <div className='name-container'>
                        <div className='hospital-name'>
                            <p>First Name</p>
                            <div className='details'>
                                <p>{user.firstname}</p>
                            </div>
                        </div>
                        <div className='hospital-name'>
                            <p>Last Name</p>
                            <div className='details'>
                                <p>{user.lastname}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='info-container'>
                    <div className='name-container'>
                        <div className='hospital-name'>
                            <p>Email</p>
                            <div className='details'>
                                <p>{user.email}</p>
                            </div>
                        </div>
                        <div className='hospital-name'>
                            <p>Role</p>
                            <div className='details'>
                                <p>{user.role}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='info-container'>
                    <div className='name-container'>
                        <div className='hospital-name'>
                            <p>Hospital</p>
                            <div className='details'>
                                <p>{user.hospital.name}</p>
                            </div>
                        </div>
                        <div className='hospital-name'>
                            <p>Phone Number</p>
                            <div className='details'>
                                <p>{user.phone}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className='confirmation-Warning-controllers'>
                <Button className='primary-button' 
                    onClick={onDecline}>Close</Button>
            </footer>
        </div>
    );
};
export default UserDetails;